import { SyntheticEvent } from 'react';
import { useForm } from 'react-hook-form';
import { createSearchParams } from 'react-router-dom';
import { useAnalytics } from 'use-analytics';
import { SocialPlatformEnum } from '../../enum/SocialPlatform.enum';

interface RegisterFormInputs {
  tos_consent: boolean;
  pp_consent: boolean;
  marketing_consent: boolean;
}

export const useSocialRegister = () => {
  const { track } = useAnalytics();

  const { trigger } = useForm<RegisterFormInputs>();

  const handleSocialRegister = async (
    _: SyntheticEvent,
    type: SocialPlatformEnum,
  ): Promise<void> => {
    const result = await trigger();

    if (result) {
      const query = createSearchParams({
        tos_consent: 'true',
        pp_consent: 'true',
        marketing_consent: 'true',
      });

      if (type === SocialPlatformEnum.Google) {
        track(
          'register_google_click',
          { event_category: 'User Registration', event_label: 'register_form' },
          () => {
            window.location.assign(`/login/google-oauth2/?${query}`);
          },
        );
      }
    }
  };

  return {
    handleSocialRegister,
  };
};
